import styled from 'styled-components';
import IconChevronDownCircle from './IconChevronDownCircle';
var IconChevronRightCircle = /*#__PURE__*/styled(IconChevronDownCircle).withConfig({
  displayName: "IconChevronRightCircle",
  componentId: "c11n-8-111-1__sc-12a0y0y-0"
})(["transform:rotate(270deg);"]);
export default IconChevronRightCircle;